export const settingsDisabledEmails = [
    'dos@crowneplazabeihai.com',
    'dos@crowneplazabeihai.com',
    'rsvn@holidayinnbaoji.com',
    'elora.gu@ihg.com',
    'holly.yu@ihg.com',
    'revenue@cphizz.com',
    'revenue@cphizz.com',
    'jingwei.zhang@ihg.com',
    'reservation@holidayinnht.com',
    'eunice.zhu@vocojincheng.com',
    'holden.tian@ihg.com',
    'apple.qu2@ihg.com',
    'shadow.hu@ihg.com',
    'athena.li@ihg.com',
    'xiaorong.wang@ihg.com',
    'apple.qu2@ihg.com',
    'ting.feng1@ihg.com',
    'michelle.chen2@ihg.com',
    '262897446@qq.com',
    'longxinwang@sunwalk.cn',
    'sissy.xu@ihg.com',
    'cherry.bi@ihg.com',
    'yoyo.zhai@ihg.com',
    'qianyao.li@ihg.com',
    'kira.zheng@ihg.com',
    'sara.yu@ihg.com',
    'qianyao.li@ihg.com',
    '1160618904@qq.com',
    'sara.yu@ihg.com',
    '614658103@qq.com',
    'tom19940513@163.com',
    'min.zhang@ihg.com',
    'cissy.chen1@ihg.com',
    'zhang.katherine@ihg.com',
    'evelyn.li1@ihg.com',
    'summer.qin@ihg.com',
    'cindy.wu5@ihg.com',
    'teng.jane@ihg.com',
    'susan.xu1@ihg.com',
    'lucy.liu4@ihg.com',
    'mike.liu@ihg.com',
    'lyne.lin1@ihg.com',
    'tracy.tan@gz63.cn',
    'jessie.yan@cphohhot.com',
    'anny.chen@thesandalwood.com.cn',
    'jerry.li4@ihg.com',
    'fiona.wang2@ihg.com',
    'lisa.ma@ihg.com',
    'ethan.liu@ihg.com',
    'lillian.wang4@ihg.com',
    'candy.liu4@ihg.com',
    'jeanne.tang@ihg.com',
    'sunny.sun@icqdh.com',
    'blair.liu1@ihg.com',
    'jiangjoyy@ihg.onmicrosoft.com',
    'judy.wang6@ihg.com',
    'blair.liu1@ihg.com',
    'izzy.jin1@ihg.com',
    'eva.wang3@ihg.com',
    '342395447@qq.com',
    'christy.liu1@ihg.com',
    'carrie.sha@icbanna.com',
    'carina.zheng@ihg.com',
    'alison.xia@ihg.com',
    'vivian.zheng1@ihg.com',
    'lily.zuo@ihg-ccecg.com',
    'koksoon.wong@ihg.com',
    '284956239@qq.com',
    'lydia.yang@ihg.com',
    'bella.fang@icxiangyang.com',
    'wendy.wu5@ihg.com',
    'wendy.wu5@ihg.com',
    'carrie.shen3@ihg.com',
    'oliver.liu@cpkunshan.com',
    'rena.ding@hihiexguiyang.com',
    'rena.ding@hihiexguiyang.com',
    'wendy.li2@ihg.com',
    'wendy.li2@ihg.com',
    'serena.qin@ihg.com',
    'serena.qin@ihg.com',
    'isabel.yang@indigolugulake.com',
    'sunny.sun6@ihg.com',
    'jessie.zheng@iclhasa.com',
    'peter.pan@lyinnexpress.com',
    'stella.zhang@himudanjiang.com',
    '13943434703@163.com',
    'cara.ai@ihg.com',
    'penny.zhang@ihg.com',
    'lily.xiang@ihg.com',
    'janus@dzsjgroup.com',
    'ivy.guo@holidayinnjn.com',
    'fiona.dai1@ihg.com',
    'ivy.guo@holidayinnjn.com',
    'echo.chen@voconanjing.com',
    'elora.gu@ihg.com',
    'teme.jing@ihg.com',
    'lisa.qiu@holidayinnxwh.com',
    'rebecca.liu@ihg.com',
    'rebecca.liu@ihg.com',
    'jodie.zheng@holidayinnnanjing.com',
    'betty.li@cpnanning.com',
    'judy.zhu@holidayinn-ny.com',
    'yuki.qin@ihg.com',
    'cynthia.cong@cplido.com',
    'xujingjing@newchaoyang.com',
    'xujingjing@newchaoyang.com',
    'amy.mao@ihg.com',
    'lucy.hsieh@ihg.com',
    'yeoman.zhang@ihg.com',
    'candy.ma@cpnanxinya.com',
    'maggen.jiang@ihg.com',
    'elaine.li@hualuxekunshan.com',
    'linda.ymz@ihg.com',
    'fiona.qiao@holidayinnnjr.cn',
    'davy.zhou@ihg.com',
    'yeoman.zhang@ihg.com',
    'nana.tang@ihg.com',
    'tracy.fu@cp-anting.com',
    'karen.gong@holidayinnsongjiang.com',
    'anita.miao1@ihg.com',
    'beverly.xue@ihg.com',
    'barrybai@shgpn.com',
    'karen.gong@holidayinnsongjiang.com',
    'brenda.peng@ihg.com',
    'ivy.pu@ihg.com',
    'shirley.jiang@ihg.com',
    'wendy.huang@ihg.com',
    'yoyo.geng@hiequjiang.com',
    'dandan_chen@ruichengroup.com',
    'brenda.peng@ihg.com',
    'lindaliang.xia@ihg.com',
    'wendy.li@icshijiazhuang.com',
    'jessiema@cpsuz.com',
    'carrie.liu@holidayinntaihu.com',
    'carrie.liu@holidayinntaihu.com',
    'weiwei.liu@ihg.com',
    '782828053@qq.com',
    'maggie.han2@ihg.com',
    'maggie.han2@ihg.com',
    'nancy.xu@cpsuzhoudongtaihu.com',
    'nancy.xu@cpsuzhoudongtaihu.com',
    'susan.chen1@ihg.com',
    '1092006025@qq.com',
    'joyce.kong1@ihg.com',
    'michelle.zhou@ihg.com',
    'alin.wu@holidayinnshenzhennanshan.com',
    'vicky.zhang@ihg.com',
    'sasa.li1@ihg.com',
    'joe.jiao@cphaiquanwan.com',
    'kai.zhou1@ihg.com',
    'kai.zhou1@ihg.com',
    'vitino.lv@ihg.com',
    'carina.zheng@ihg.com',
    'jane.zhao@ihg.com',
    'revm@cpjinan.com',
    'peter.huang@ihg.com',
    'cathy.zhao@cptjbh.com',
    'stella.zhang2@ihg.com',
    'joan.wangyang@ihg.com',
    'nancy.xu@cptjmjn.com',
    'tracy.wu1@ihg.com',
    'amy.ren@tywzjr.com',
    '13605422273@163.com',
    'jennifer.gao1@ihg.com',
    'erin.li@cpwhov.com',
    'vivi.gu@ihg.com',
    'vivi.gu@ihg.com',
    'revenue@vocowuhan.com',
    'snow.bai@cpwxcc.com',
    'jack.wang8@ihg.com',
    'niki.hua@ihg.com',
    'jack.wang8@ihg.com',
    'teddy.xiong@hualuxewuxi.com',
    'lyn.yin@ihg.com',
    'celine.wu@ihg.com',
    'reservations@aahmco.cn',
    'jane.fu@ihg.com',
    'helen.luo@icxiamen.com',
    'antony.zhang@ihg.com',
    'helen.liao1@ihg.com',
    'helen.liao1@ihg.com',
    'gm@hiexyc.com',
    'yimin.wang@ihg.com',
    'andrea.zhang@crowneplazayantai.com',
    'janice.he@ihg.com',
    'yan.li1@ihg.com',
    'isabella.li4@ihg.com',
    'alva.jin@crowneplazazj.com',
    'cynthia.wu@ihg.com',
    'sam.sun5@ihg.com',
    'sam.sun5@ihg.com',
    'katriya.li@ihg.com',
    'heather.bai1@ihg.com',
    'heather.bai1@ihg.com',
    'kelly.jia@ihg.com',
    'william.luo3@ihg.com',
    'wangziyu96@126.com',
    'vivian.feng3@ihg.com',
    'catherine.zhang5@ihg.com',
    'kelvin.liu4@ihg.com',
    'yanshu.zhai@ihg.com',
    'yanshu.zhai@ihg.com',
    'jingwei.zhang@ihg.com',
    '1824160722@qq.com',
    '1771291461@qq.com',
    'linda.sun@ihg.com',
    '2753605202@qq.com',
    'samuel.lee@ihg.com',
    'jeffrey.huang1@ihg.com',
    '632834168@qq.com',
    'xin.zhang2@ihg.com',
    'rosally@yeah.net',
    'yoyo.ma@hojocsairport.com',
    'zhaohaijuan@sunwalk.cn',
    'sabrina.he1@ihg.com',
    'roy.wang@ihg.com',
    'vicky.diao@cpctuch.com',
    'jessie.liu@ihg.com',
    'max.zhao1@ihg.com',
    'stone.cao@ihg.com',
    'flora.xie@ic-sanchalake.com',
    'li.xia@ihg.com',
    'roger.gao@cptianfu.com',
    'tom19940513@163.com',
    'cris.liu@ihg.com',
    'coco.xu1@ihg.com',
    'sierra.jiang@hiqdcc.com',
    'steven.cui1@ihg.com',
    'sharon.wang3@ihg.com',
    'mike.zhang3@ihg.com',
    'julia.wang3@ihg.com',
    'jack.wang@ihg.com',
    '1318102545@qq.com',
    'yvonne.tong@ihg.com',
    'laura.feng@ihg.com',
    'elena.pang@cphohhot.com',
    'alex.liu@thesandalwood.cn',
    'ichefei.res@intercontinentalhefei.com',
    'sammi.du@ihg.com',
    'sarah.feng@ihg.com',
    'brian.zheng@ihg.com',
    '598990629@qq.com',
    'joyce.qiu@crowneplazahzaux.com',
    'eric.kee@ihg.com',
    '1063639077@qq.com',
    'blair.liu1@ihg.com',
    '243677485@qq.com',
    'susanzheng.xu@ihg.com',
    '645685034@qq.com',
    'eva.wang@cphuizhou.com',
    'ricky.tan@crowneplazataizhou.com',
    'irwen.wang1@ihg.com',
    'carlson.li1@ihg.com',
    '973590124@qq.com',
    'rsvn@icquanzhou.com',
    'von.go@ihg.com',
    '240186355@qq.com',
    'robbert.manussen@ihg.com',
    'jason.hu3@ihg.com',
    'reise.li@ihg.com',
    '2296535445@qq.com',
    'lucy.yan@ihg.com',
    'ken.yi1@ihg.com',
    'carrie.shen3@ihg.com',
    'sarah.ding@ihg.com',
    'jessiejiang1210@163.com',
    'jessiejiang1210@163.com',
    'jinming.zhang1@ihg.com',
    'alvin.zhu@ihg.com',
    'sunday.wang@ihg.com',
    'sunday.wang@ihg.com',
    'richie.yang@ihg.com',
    'jennifer.shi2@ihg.com',
    'totti.zhao@ihg.com',
    'niky.yu@lyinnexpress.com',
    'eva.li@himudanjiang.com',
    'david.zhang3@ihg.com',
    'steve.ding@ihg.com',
    'carnival.xu@intercontinentalningbo.com',
    'david.zhu3@ihg.com',
    'ally@dzsjgroup.com',
    'wendy.xu2@ihg.com',
    'res@holidayinnxg.com',
    'wendy.xu2@ihg.com',
    '320710018@qq.com',
    'lisa.qiu@holidayinnxwh.com',
    'connie.li1@ihg.com',
    'rebecca.liu@ihg.com',
    'wilson.zhou2@ihg.com',
    'jeffery.xu@cpnanning.com',
    'duan.vane@ihg.com',
    'allen.li2@ihg.com',
    'fo@cplido.com',
    'grace.lan3@ihg.com',
    'grace.lan3@ihg.com',
    'amy.li@cpsunpalace.cn',
    'eric.swanson@ihg.com',
    '1023454729@qq.com',
    'tony.geerts@ihg.com',
    'douglas.yue@ihg.com',
    '297180710@qq.com',
    'evali@holidayinnnjr.cn',
    'suki.yu1@ihg.com',
    '1023454729@qq.com',
    'ivan.tan4@ihg.com',
    'cathy.yang2@ihg.com',
    'carol.xie1@ihg.com',
    'anita.miao1@ihg.com',
    'jessie.yang@crowneplaza-jinxiu.com',
    'carol.xie1@ihg.com',
    '1332389813@qq.com',
    'rsvn@holidayinnxian.com',
    'jerry.cao3@ihg.com',
    'jessie.zheng@icshaanxi.com',
    'jerry.wu1@ihg.com',
    'dandan_chen@ruichengroup.com',
    '1332389813@qq.com',
    'leslie.cao@ihg.com',
    '354252342@qq.com',
    '1067874654@qq.com',
    'jenny.zhao@holidayinntaihu.com',
    'ethan.kuai@ihg.com',
    'victor.wang@ihg.com',
    'lance.zhang@hi-sanyabay.com',
    'lily.zhang6@ihg.com',
    'hansen.yang@cpsuzhoudongtaihu.com',
    'hansen.yang@cpsuzhoudongtaihu.com',
    'david.zhouqing@ihg.com',
    'li.xiaofang@hualuxesuzhou.com',
    'michelle.zhou@ihg.com',
    'johnson.liu6@ihg.com',
    'tim.hooton@ihg.com',
    'elain.wu@hotelindigoshenzhen.com',
    'michelle.zhang4@ihg.com',
    '524493642@qq.com',
    'kai.zhou1@ihg.com',
    'tao.shi@ihg.com',
    'reservations@qteven.com',
    'jack.cui2@ihg.com',
    'sandy.dong1@ihg.com',
    'peter.huang@ihg.com',
    'ley.li@cptjbh.com',
    'ted.chen1@ihg.com',
    'lisa.yang4@ihg.com',
    'echo.chen@cptjmjn.com',
    '1625858848@qq.com',
    'zhaojieying@tywzjr.com',
    '13605422273@163.com',
    '1417397833@qq.com',
    'jimson.hao@ihg.com',
    'fuat.koroglu@ihg.com',
    'fuat.koroglu@ihg.com',
    'gm@vocowuhan.com',
    'adrien.zhu1@ihg.com',
    'jack.wang8@ihg.com',
    'reservation@intercontinentalwuxi.com',
    'jack.wang8@ihg.com',
    'eva.li2@ihg.com',
    'kelvin.zhou@ihg.com',
    'zoe.zou1@ihg.com',
    'yumi0020@163.com',
    'reservations@crowneplazaxm.com',
    'troy.fu1@ihg.com',
    'beck.chen@ihg.com',
    '1258019778@qq.com',
    'gm@hiexyc.com',
    'gm@hiex-horgos.com',
    'reservation@crowneplazayantai.com',
    'david.feng2@ihg.com',
    'ellengao.icfs@polyhotels.com',
    'sales@hi-shunde.com',
    'rsvn@crowneplazazj.com',
    'iriny.chen@crowneplazazhangzhou.com',
    'john.wang4@ihg.com',
    'john.wang4@ihg.com',
    'qi.li1@ihg.com',
    'jin.ma@ihg.com',
    'jimmy.wang4@ihg.com',

    'betty.xie1@ihg.com',
    'jean.zhao1@ihg.com',
    'wendy.deng@ihg.com',
    'richard.yuan@ihg.com',
    'ivy.mao1@ihg.com',
    'rena.tan@ihg.com',
    'rebecca.he1@ihg.com',
    'sarah.wen@ihg.com',
    'crystal.tian1@ihg.com',
    'lexi.nie@ihg.com',
    'christie.huang@ihg.com',
    'apple.qu2@ihg.com',
    'tracy.xie@ihg.com',
    'bingqian.jiang@ihg.com',
    'jacky.xiong2@ihg.com',
    'Medusa.Li1@ihg.com',
    'Yvonne.Xu@ihg.com',
    'Elva.Zhou@ihg.com',
    'Lyonel.Xia@ihg.com',
    'Joann.Gao@ihg.com',
    'Ruby.Hu@ihg.com',
    'Joanna.Liu@ihg.com',
    'Yuki.Liu2@ihg.com',
    'Wendy.Xu6@ihg.com',
    'Renny.Yip@ihg.com',
    'Josie.Zhou@ihg.com',
    'Yue.Yu2@ihg.com',
    'Calvin.Chen2@ihg.com',
    'dupcheng7@gmail.com',
    'su8205@126.com',
    'Chanjoo.Lee@ihg.com',
    'Homan.Chen1@ihg.com',
    'ian.chen4@ihg.com',
    'Ada.Wang5@ihg.com',
    'Amber.Sun@ihg.com',
    'Amy.Mao@ihg.com',
    'angel.cai1@ihg.com',
    'Janis.Wang@ihg.com',
    'Carina.Zheng@ihg.com',
    'Kary.Li@ihg.com',
    'Christy.Liu1@ihg.com',
    'Lisa.Fan2@ihg.com',
    'Cindy.Chang3@ihg.com',
    'Edgar.Li@ihg.com',
    'Elora.Gu@ihg.com',
    'evelyn.li1@ihg.com',
    'Mike.Liu@ihg.com',
    'Nana.Tang@ihg.com',
    'Nicky.Kang@ihg.com',
    'Nikki.Li@ihg.com',
    'Oscar.Chen@ihg.com',
    'ShuyunPhoebe.Wei@ihg.com',
    'Rachel.Luo@ihg.com',
    'Rina.Wang2@ihg.com',
    'Selena.Yao@ihg.com',
    'Serena.Sun1@ihg.com',
    'Shirley.Wang6@ihg.com',
    'susan.tian@ihg.com',
    'Susan.Zou1@ihg.com',
    'Vanessa.Zhai@ihg.com',
    'Yumao.Zhou@ihg.com',
    'Kyle.Li@ihg.com',
    'Rick.Chen2@ihg.com',
    'sunny.sun6@ihg.com',
    'Yimin.Wang@ihg.com',
    'alison.xia@ihg.com',
    'ally@dzsjgroup.com',
    'allen.li2@ihg.com',
    'alvin.zhu@ihg.com',
    'amanda.li@crowneplazazh.com',
    'amy.li@cpsunpalace.cn',
    'andrea.zhang@crowneplazayantai.com',
    '172867904@qq.com',
    'qi.li1@ihg.com',
    'antony.zhang@ihg.com',
    'reservation@intercontinentalwuxi.com',
    'barrison.chen@vcsnowworld.com.cn',
    'yuan.li1@ihg.com',
    'beck.chen@ihg.com',
    '13983974828@163.com',
    'revenue@cphizz.com',
    'carnival.xu@intercontinentalningbo.com',
    'catherine.zhang5@ihg.com',
    '392081748@qq.com',
    '943189067@qq.com',
    'celine.wu@ihg.com',
    'cindy.wu5@ihg.com',
    'frontoffice@crowneplazayantai.com',
    '907559897@qq.com',
    '1824160722@qq.com',
    'cris.liu@ihg.com',
    'lidan@cgonrhiex.com',
    'daniel.li1@newchaoyang.com',
    'davy.zhou@ihg.com',
    'echo.chen@cptjmjn.com',
    'elena.pang@cphohhot.com',
    'ellengao.icfs@polyhotels.com',
    'xujingjing@newchaoyang.com',
    'eric.kee@ihg.com',
    '2413726922@qq.com',
    '297180710@qq.com',
    'ford.huang@ihg.com',
    'grace.lan3@ihg.com',
    'helen.luo@icxiamen.com',
    'helena.dai@ihg.com',
    'holly.yu@ihg.com',
    'isabel.yang@indigolugulake.com',
    'ivan.tan4@ihg.com',
    'ivy.pu@ihg.com',
    'jack.wang8@ihg.com',
    'janus@dzsjgroup.com',
    'gm@hiex-horgos.com',
    'rsvnmgr@nkgha.com',
    'jeanne.tang@ihg.com',
    'liu552jb@qq.com',
    'jennifer.shi2@ihg.com',
    'jerry.cao3@ihg.com',
    'jerry.li4@ihg.com',
    'jessie.yan@cphohhot.com',
    'jimmy.wang4@ihg.com',
    'joe.jiao@cphaiquanwan.com',
    'john.wang4@ihg.com',
    'judy.zhu@holidayinn-ny.com',
    'judy.wang6@ihg.com',
    'juliet.song@intercon-indigowuxi.com',
    'kai.zhou1@ihg.com',
    'zhang.katherine@ihg.com',
    'katriya.li@ihg.com',
    'reservation@icxiamen.com',
    'kelly.jia@ihg.com',
    'kitty.liu@cphohhot.com',
    'ichefei.res@intercontinentalhefei.com',
    'reservation@crowneplazayantai.com',
    'leslie.cao@ihg.com',
    'linda.ymz@ihg.com',
    'linda.sun@ihg.com',
    'lindaliang.xia@ihg.com',
    'lucy.liu4@ihg.com',
    'rsvn@icquanzhou.com',
    'tao.shi@ihg.com',
    '1318102545@qq.com',
    'michelle.zhang4@ihg.com',
    'mike.zhang3@ihg.com',
    'rsvn@holidayinnbaoji.com',
    'nancy.xu@cptjmjn.com',
    'niki.hua@ihg.com',
    'patrick.sun@ihg.com',
    'penny.zhang@ihg.com',
    'chi.gao@geely.com',
    'richie.yang@ihg.com',
    '2537648438@qq.com',
    'sam.sun5@ihg.com',
    'fo@intercontinentalningbo.com',
    'shadow.hu@ihg.com',
    'shirley.jiang@ihg.com',
    'sierra.jiang@hiqdcc.com',
    'stella.zhang2@ihg.com',
    'steven.cui1@ihg.com',
    'suki.yu1@ihg.com',
    'reservation@holidayinnht.com',
    'rsvn@holidayinnxian.com',
    '1063639077@qq.com',
    'sunny.sun@icqdh.com',
    'susan.xu1@ihg.com',
    'ted.chen1@ihg.com',
    'teresa.tang@ihg.com',
    'yanshu.zhai@ihg.com',
    '632834168@qq.com',
    'tracy.wu1@ihg.com',
    'troy.fu1@ihg.com',
    'duan.vane@ihg.com',
    'vitino.lv@ihg.com',
    'vivian.feng3@ihg.com',
    '1625858848@qq.com',
    'wendy.li2@ihg.com',
    'wendy.li@crowneplazaxinghaidl.com',
    'jinming.zhang1@ihg.com',
    'min.zhang@ihg.com',
    'yan.li1@ihg.com',
    '2753605202@qq.com',
    'yueyao.zhang@ihg.com',
    'yuki.qin@ihg.com',
    'zoe.zou1@ihg.com',
    '524493642@qq.com',
    '1612722008@qq.com',
    'crmh@ihg.com',
    'serena.qin@ihg.com',
    'sunday.wang@ihg.com',
    'reservation@iclijiang.com',
    'jingwei.zhang@ihg.com',
    'heather.bai1@ihg.com',
    'eunice.zhu@vocojincheng.com',
    'jin.ma@ihg.com',
    'holden.tian@ihg.com',
    'eva.li@himudanjiang.com',
    'christopher.cheng@ihg.com',
    'athena.li@ihg.com',
    'lily.wang@vococsairport.com',
    'gm@hiexyc.com',
    'sissy.xu@ihg.com',
    'hansen.yang@cpsuzhoudongtaihu.com',
    'aa@hiexyc.com',
    'erin.wang@sunachotels.com.cn',
    'yumi0020@163.com',
    'y@cptianfu.com',
    '1771291461@qq.com',
    'mengfan_ming@ruichengroup.com',
    'samuel.lee@ihg.com',
    'joan.zhang2@ihg.com',
    'cissy.chen1@ihg.com',
    'eva.li2@ihg.com',
    'yoyo.ma@hojocsairport.com',
    'sabrina.he1@ihg.com',
    'summer.qin@ihg.com',
    '583461282@qq.com',
    'reservations@aahmco.cn',
    'anny.chen@thesandalwood.com.cn',
    'reservation.mgr@icchangsha.com',
    'flora.xie@ic-sanchalake.com',
    'roger.gao@cptianfu.com',
    'teddy.xiong@hualuxewuxi.com',
    'marcello.zhao@crowneplazataizhou.com',
    'coco.xu1@ihg.com',
    'sharon.wang3@ihg.com',
    'carrie.sha@icbanna.com',
    'julie.pan@intercontidl.com',
    'jianghuahua7777@163.com',
    'lily.zuo@ihg-ccecg.com',
    'alex.liu@thesandalwood.cn',
    'mark@thesandalwood.com.cn',
    'ricky.tan@crowneplazataizhou.com',
    'bella.fang@icxiangyang.com',
    '2451514037@qq.com',
    'snow.bai@cpwxcc.com',
    'carlson.li1@ihg.com',
    'jessie.zheng@iclhasa.com',
    'revenue@vocowuhan.com',
    'peter.pan@lyinnexpress.com',
    'vivi.gu@ihg.com',
    'stella.zhang@himudanjiang.com',
    '973590124@qq.com',
    '240186355@qq.com',
    'rachel.wang@ihg-ccecg.com',
    'jennifer.gao1@ihg.com',
    'cara.ai@ihg.com',
    '2296535445@qq.com',
    '870857026@qq.com',
    'totti.zhao@ihg.com',
    '1452861190@qq.com',
    '13605422273@163.com',
    'niky.yu@lyinnexpress.com',
    'rsvn@lyinnexpress.com',
    'echo.chen@voconanjing.com',
    'betty.li@cpnanning.com',
    'amy.ren@tywzjr.com',
    'steve.ding@ihg.com',
    'candy.ma@cpnanxinya.com',
    '270152093@qq.com',
    'joan.wangyang@ihg.com',
    'fiona.qiao@holidayinnnjr.cn',
    'jeffery.xu@cpnanning.com',
    '1505564253@qq.com',
    'barrybai@shgpn.com',
    'revm@cpjinan.com',
    'tony.geerts@ihg.com',
    'vic.hong@cpnanxinya.com',
    'brenda.peng@ihg.com',
    'jane.zhao@ihg.com',
    'wendy.huang@ihg.com',
    'yoyo.geng@hiequjiang.com',
    '1332389813@qq.com',
    'vincent.zhang@ihg.com',
    'jessie.zheng@icshaanxi.com',
    'peng.chen@ihg.com',
    'dandan_chen@ruichengroup.com',
    'jerry.wu1@ihg.com',
    'michelle.zhou@ihg.com',
    'wendy.li@icshijiazhuang.com',
    '354252342@qq.com',
    'jessiema@cpsuz.com',
    '1067874654@qq.com',
    'susan.chen1@ihg.com',
    'olivia.wang@ihg.com',
    'jenny.zhao@holidayinntaihu.com',
    'reservation@hualuxesuzhou.com',
    'ethan.kuai@ihg.com',
    'kate.zhu@cpsuzhoudongtaihu.com',
    'david.zhouqing@ihg.com',
    '1144692450@qq.com',
    'li.xiaofang@hualuxesuzhou.com',
    'backham.news@qq.com',
    'liu.yilia@ihg.com',
    'reservations@qteven.com',
    'jack.cui2@ihg.com',
    'rene.wang@ihg.com',
    'sandy.dong1@ihg.com',
    'lisa.yang4@ihg.com',
    '1061239114@qq.com',
    'zhaojieying@tywzjr.com',
    '1417397833@qq.com',
    'fuat.koroglu@ihg.com',
    '2621654099@qq.com',
    'gm@vocowuhan.com',
    'caihuan0727@163.com',
    'adrien.zhu1@ihg.com',
    'wilson.fang@cpwxcc.com',
    'Li.xiaojun@ihg.com',
    '13209622467@163.com',
    'gcrmh@ihg.com',
    'longxinwang@sunwalk.cn',
    'Carrie.liu@holidayinntaihu.com',
    'dos@crowneplazabeihai.com',
    'xiaorong.wang@ihg.com',
    'ting.feng1@ihg.com',
    'cherry.bi@ihg.com',
    'yoyo.zhai@ihg.com',
    'qianyao.li@ihg.com',
    'kira.zheng@ihg.com',
    'sara.yu@ihg.com',
    'teng.jane@ihg.com',
    'lyne.lin1@ihg.com',
    'fiona.wang2@ihg.com',
    'ethan.liu@ihg.com',
    'lillian.wang4@ihg.com',
    'blair.liu1@ihg.com',
    'eva.wang3@ihg.com',
    'vivian.zheng1@ihg.com',
    '284956239@qq.com',
    'lydia.yang@ihg.com',
    'wendy.wu5@ihg.com',
    'carrie.shen3@ihg.com',
    'oliver.liu@cpkunshan.com',
    'rena.ding@hihiexguiyang.com',
    'ivy.guo@holidayinnjn.com',
    'fiona.dai1@ihg.com',
    'rebecca.liu@ihg.com',
    'maggie.han2@ihg.com',
    'helen.liao1@ihg.com',
    'karen.gong@holidayinnsongjiang.com',
    'teme.jing@ihg.com',
    'lisa.qiu@holidayinnxwh.com',
    'jodie.zheng@holidayinnnanjing.com',
    'yeoman.zhang@ihg.com',
    'maggen.jiang@ihg.com',
    'elaine.li@hualuxekunshan.com',
    'tracy.fu@cp-anting.com',
    'weiwei.liu@ihg.com',
    '782828053@qq.com',
    'erin.li@cpwhov.com',
    'jane.fu@ihg.com',
    'isabella.li4@ihg.com',
    'cynthia.wu@ihg.com',
    'ken.yi1@ihg.com',
    'sarah.ding@ihg.com',
    'jessiejiang1210@163.com',
    'wendy.xu2@ihg.com',
    'res@holidayinnxg.com',
    '320710018@qq.com',
    'connie.li1@ihg.com',
    'wilson.zhou2@ihg.com',
    '1023454729@qq.com',
    'douglas.yue@ihg.com',
    'cathy.yang2@ihg.com',
    'william.luo3@ihg.com',
    'carol.xie1@ihg.com',
    'wangziyu96@126.com',
    'lisa.qiu@ihg.com',
    'victor.wang@ihg.com',
    'lance.zhang@hi-sanyabay.com',
    'lily.zhang6@ihg.com',
    'jeffrey.huang1@ihg.com',
    'jimson.hao@ihg.com',
    'georgexuejian.wang@ihg.com',
    'xin.zhang2@ihg.com',
    'reservations@crowneplazaxm.com',
    '1151327742@qq.com',
    'roy.wang@ihg.com',
    'jackie.kou@ihg.com',
    'vicky.diao@cpctuch.com',
    'jessie.liu@ihg.com',
    'vivian.han@ihg.com',
    'max.zhao1@ihg.com',
    'alice.liu2@ihg.com',
    '1258019778@qq.com',
    'stone.cao@ihg.com',
    'li.xia@ihg.com',
    'sales@hi-shunde.com',
    'julia.wang3@ihg.com',
    'iriny.chen@crowneplazazhangzhou.com',
    'lynn.yang2@ihg.com',
    '2521322123@qq.com',
    'anita.lin@cpkmgdt.com',
    'mike.chen1@ihg.com',
    'yvonne.tong@ihg.com',
    'sammi.du@ihg.com',
    'derek.xu@ihg.com',
    'brian.zheng@ihg.com',
    'harriett.ma1@ihg.com',
    '598990629@qq.com',
    'william.wang3@ihg.com',
    '878059861@qq.com',
    '243677485@qq.com',
    '2857096774@qq.com',
    '1919715102@qq.com',
    'eva.wang@cphuizhou.com',
    'von.go@ihg.com',
    'jason.hu3@ihg.com',
    'rsvn@holidayinnnanjing.com',
    'crystal.deng@ihg.com',
    '1632170880@qq.com',
    'reise.li@ihg.com',
    'jack.li@hualuxekunshan.com',
    'lucy.yan@ihg.com',
    'barry.cao@cp-anting.com',
    'vicky.yu@ihg.com',
    '839459239@qq.com',
    'allen.zhang5@ihg.com',
    'lily.liu1@ihg.com',
    '77242104@qq.com',
    'jia_dai@126.com',
    'leo.zhang3@ihg.com',
    'gianna.li@ihg.com',
    'testci_vs_di@yopmail.com',
    'testci_as_default_app@yopmail.com',
    'terry.fu@ihg.com',
    'Cecilia.Li1@ihg.com',
    'elsie.xu@crowneplazafudan.com',
    'JiangJoyy@ihg.com',
    'Ada.yao2@ihg.com',
    'Peony.Kuang@ihg.com',
    'revenue.mgr@cpwenjiang.com',
    'aimee.wu@ihg.com',
    'katherine.cheng@ihg.com',
    'jane.li5@ihg.com',
    'Nancy.Li4@ihg.com',
    'anna.zhang@hichangchun.com.cn',
    'connieyan.icgz@polyhotels.com',
    'Pure.Li@ihg.com',
    'reiko.dai@holidayinn-shhqc.com.cn',
    'april.han@ihg.com',
    'cathy.cao@hi-hiexwuxi.com',
    'Jacky.wang8@ihg.com',
    'lili.wang@holidayinn-changanwest.com',
];
